module.exports = require('./helpers/bundle-url').getBundleURL('37XjS') + "logo-dark.eefe0b7f.svg";